/* tslint:disable */
import { FormikActions } from 'formik';
import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import ContentLoader from 'react-content-loader';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Table } from 'reactstrap';
import Paginate from '../../../components/table/paginate';
import SortedColumn from '../../../components/table/sorted-column';
import Announce from '../../../components/templates/announce';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import {
    IFilterStudent,
    IStudentItem,
    IStudentPageProps,
    IStudentPageState,
    StudentSearchInitialValues
} from '../../../models/components/course-student-list';
import * as Actions from '../../../store/actions/coursePage';
import * as BackgroundActions from '../../../store/actions/background';
import { SecureImage } from '../../core/secureImage';
import Loading from '../../loading/loading';
import { event } from 'jquery';
import { background } from '../../../store/constants/all';
import ProgressCircle from '../../progress-circle/progress-circle';

const T = Translator.create();
const _logger = Log.create('StudentAddModal');
const _common = new Common();

const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
];

const IS_OPEN = true;
const IS_CLOSED = false;
class CourseStudentList extends Component<IStudentPageProps, IStudentPageState> {
    state: IStudentPageState = {
        filters: Object.assign({}, StudentSearchInitialValues),
        isSearchBoxOpen: false,
        filterIsOpen: false,
        student_list: [],
        selected_ids: [],
        selectedOption: [{ value: 10, label: '10' }],
        currentTab: '_classStudentsTab'
    };

    triggerSearchBox() {
        this.setState({
            ...this.state,
            isSearchBoxOpen: !this.state.isSearchBoxOpen
        });
    }

    closeSearchBox() {
        this.setState({
            ...this.state,
            isSearchBoxOpen: !this.state.isSearchBoxOpen,
            filters: {
                ...this.state.filters,
                query: ''
            }
        });
        this.getStudents();
    }

    public componentDidMount() {
        this.getStudents();
    }
    public componentDidUpdate(prevProps: IStudentPageProps, prevState: IStudentPageState) {


        if (prevProps.coursePageClassId !== this.props.coursePageClassId) {
            this.getStudents();
            if (this.state.isSearchBoxOpen === IS_OPEN) {
                this.closeSearchBox();
            }
        }
        if (prevState.isSearchBoxOpen !== this.state.isSearchBoxOpen && this.state.isSearchBoxOpen === IS_CLOSED) {
            this.getStudents();
        }
    }

    public getStudents() {
        this.props.dispatch(
            Actions.getCourseStudentList(this.props.coursePageClassId!, this.state.filters, false, 'getCourseStudentList', 'get')
        );
    }

    public searchStudent = (event: any) => {
        this.state.filters.query = event.target.value;
        this.state.filters.page = 1;
        this.setState(this.state);
        this.getStudents();
    };

    public onStudentImported = () => {
        this.getStudents();
    };

    public sort = (sortKey: string, orderBy: string) => {
        this.state.filters.orderBy = sortKey + '_' + orderBy;
        this.setState(this.state);
        this.getStudents();
    };

    public onPageChange = (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        this.getStudents();
    };

    public onFormReset = () => {
        this.state.filters = Object.assign({}, StudentSearchInitialValues);
        this.setState(this.state);
        this.getStudents();
    };

    public onSelectStudent = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e && e.currentTarget) {
            const checkedList = Object.assign([], this.state.selected_ids);
            const stringId: string = e.currentTarget.dataset.id || '';
            const id = parseInt(stringId, 10);

            if (e.target.checked) {
                checkedList.push(id);
            } else {
                const index = checkedList.indexOf(id);
                if (index !== -1) {
                    checkedList.splice(index, 1);
                }
            }
            this.setState({
                ...this.state,
                selected_ids: checkedList
            });
        }
    };

    public onSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e && e.currentTarget) {
            if (e.currentTarget.checked) {
                const ALL_IDS: number[] = [];
                this.state.student_list && this.state.student_list.map((item: any) => ALL_IDS.push(item.student_id));
                this.setState({
                    ...this.state,
                    selected_ids: [...this.state.selected_ids, ...ALL_IDS]
                });
            } else {
                this.setState({
                    ...this.state,
                    selected_ids: []
                });
            }
        }
    };

    public checker = (arr: number[], target: number[]): boolean => {
        if (arr.length && target.length) {
            return target.every((item: number) => arr.includes(item));
        } else return false;
    };

    public onFilterStudent(model: IFilterStudent, FormActions: FormikActions<IFilterStudent>) {
        this.state.filters = model;
        this.state.filters.page = 1;
        this.state.filterIsOpen = true;
        this.setState(this.state);
        this.getStudents();
        FormActions.setSubmitting(false);
    }
    // tslint:disable-next-line
    static getDerivedStateFromProps(props: IStudentPageProps, state: IStudentPageState) {
        let hasNewState: boolean = false;
        if (props.studentList) {
            hasNewState = true;
            state.student_list = props.studentList;
            state.student_list = props.studentList;
        }

        if (hasNewState) {
            return state;
        } else {
            return null;
        }
    }

    public onChangeTake = (event: any) => {
        this.state.selectedOption = event;
        this.setState({ selectedOption: event });
        this.state.filters.take = event.value;
        this.setState(this.state);
        this.getStudents();
    };

    downloadStudentDatas = () => {
        this.props.dispatch(BackgroundActions.GetDownloadStudentListReport(this.props.coursePageClassId!, this.props.coursePageActivityId!))
    }


    public render() {
        const studentList = this.props.studentList && this.props.studentList.length ? this.props.studentList : [];

        const Tablea = (
            <div className="page-container student-page">
                <div className="page-content" style={{ paddingTop: 80 }}>
                    <div className="container">
                        <div className="xx" style={{ alignItems: 'flex-end' }}>
                            <div className='div0 mb-2'>
                                <b>{T.t('r_students')}</b>
                                <span className='count ml-3'>
                                    <span className='badge badge-pill badge-light mr-2' style={{ backgroundColor: "rgb(217, 218, 220)", fontWeight: 600, fontSize: "13px", color: "black" }}>
                                        {this.props.filters ? this.props.filters.total : 0}
                                    </span>
                                </span>
                            </div>
                            {/* <div className='d-flex align-items-center'> */}
                            <div className='div1 mb-2'>
                                <div className="lead-search-bar" style={{ position: 'relative', textAlign: 'end' }}>
                                    <div className="question-filter p-0">
                                        {(this.state.isSearchBoxOpen == false) ? (
                                            <div className="options">
                                                <a
                                                    className="ml-3 mr-3"
                                                    data-toggle="collapse"
                                                    aria-expanded="true"
                                                    onClick={() => this.triggerSearchBox()}
                                                >
                                                    <i className="material-icons mr-2 align-middle">search</i>
                                                    {T.t('r_gen_search')}
                                                </a>
                                            </div>
                                        ) : (
                                            <div
                                                className='search collapse show'
                                                style={{ position: 'unset' }}
                                            >
                                                <div className="input-group">
                                                    <div
                                                        data-toggle="collapse"
                                                        className="input-group-prepend collapsed"
                                                        aria-expanded="false"
                                                    >
                                                        <div
                                                            className="input-group-text"
                                                            onClick={() => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    isSearchBoxOpen: !this.state.isSearchBoxOpen,
                                                                    filters: {
                                                                        ...this.state.filters,
                                                                        query: ''
                                                                    }
                                                                });
                                                            }}
                                                        >
                                                            <i className="material-icons">close</i>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="inlineFormInputGroup"
                                                        placeholder={T.t('r_gen_search')}
                                                        value={this!.state!.filters!.query!}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                                            this.setState({
                                                                ...this.state,
                                                                filters: {
                                                                    ...this.state.filters,
                                                                    query: event.target.value
                                                                }
                                                            })
                                                        }
                                                        onKeyUp={event => this.searchStudent(event)}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                            {studentList && studentList.length > 0 && this.props.classes?.classes?.length > 0 &&
                                <div className="div2 mb-2">
                                    <div className="options d-inline-flex align-items-center">
                                        <button
                                            onClick={() => this.downloadStudentDatas()}
                                            className="category-tag-square tag-green"
                                            style={{ height: '36px', lineHeight: 'normal' }}
                                        >
                                            <i className="material-icons mr-1">arrow_downward</i>
                                            <span>{T.t('r_gen_download_full_data')}</span>
                                        </button>
                                    </div>
                                </div>}
                            <div className='div3 mb-2 minw-90'> <Select options={options} value={this.state.selectedOption} onChange={this.onChangeTake} /></div>
                            {/* </div> */}
                        </div>
                        {this.props.classes?.classes?.length > 0 &&
                            <Loading spinnerId={'getCourseStudentList'}>
                                <div>
                                    <ContentLoader speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" viewBox="0 0 700 300">
                                        <circle cx="10" cy="25" r="5" />
                                        <rect x="25" y="20" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="50" r="5" />
                                        <rect x="25" y="45" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="75" r="5" />
                                        <rect x="25" y="70" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="100" r="5" />
                                        <rect x="25" y="95" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="125" r="5" />
                                        <rect x="25" y="120" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="150" r="5" />
                                        <rect x="25" y="145" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="175" r="5" />
                                        <rect x="25" y="170" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="200" r="5" />
                                        <rect x="25" y="195" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="225" r="5" />
                                        <rect x="25" y="220" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="250" r="5" />
                                        <rect x="25" y="245" rx="5" ry="5" width="650" height="6" />
                                        <circle cx="10" cy="275" r="5" />
                                        <rect x="25" y="270" rx="5" ry="5" width="650" height="6" />
                                    </ContentLoader>
                                </div>
                            </Loading>}
                        <div className="page-table p-0 m-t-0" id="getCourseStudentList_Content">
                            {studentList && studentList.length > 0 ?

                                <Table className="table-user-list table-ellipsis table-mobile" striped={true} hover={true} borderless={true}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#eaeaea' }}>
                                            <th scope="col" className="text-center">
                                                {T.t('r_profile_photo')}
                                            </th>
                                            <SortedColumn
                                                datacell="firstName"
                                                className=" d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_firstname')}
                                                sortkey="firstName"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="lastName"
                                                className=" d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_lastname')}
                                                sortkey="lastName"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="userName"
                                                className=" d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_username')}
                                                sortkey="userName"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="lastLoginDate"
                                                className=" d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_last_login_date')}
                                                sortkey="lastLoginDate"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="progress"
                                                className=" d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_progress')}
                                                sortkey="progress"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {studentList.map((item: IStudentItem) => {
                                            return (
                                                <tr key={'student-' + item.userId} data-title={item.userName} style={{ cursor: 'initial' }}>
                                                    <td data-label="Profil Resmi" className="text-center">
                                                        <SecureImage
                                                            imageUrl={item.avatarPath ? item.avatarPath : ''}
                                                            style={{ maxWidth: '50px' }}
                                                            class={''}
                                                        />
                                                    </td>
                                                    <td data-label={T.t('r_firstname')} className="text-center">
                                                        {item.firstName}
                                                    </td>
                                                    <td data-label={T.t('r_lastname')} className="text-center">
                                                        {item.lastName}
                                                    </td>
                                                    <td data-label={T.t('r_username')} className="text-center">
                                                        {item.userName}
                                                    </td>
                                                    <td data-label={T.t('r_last_login_date')} className="text-center">
                                                        {item.lastLoginDate
                                                            ? Moment(item.lastLoginDate).format(
                                                                _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 1) +
                                                                ' HH:mm'
                                                            )
                                                            : '-'}
                                                    </td>
                                                    <td data-label={T.t('r_progress')} className="text-center student_progress">
                                                    <ProgressCircle disableTooltip={true}  percent={item.progress} />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>

                                </Table> : <>
                                    <Table className="table-user-list table-ellipsis table-mobile" striped={true} hover={true} borderless={true}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                                <th scope="col" className="d-none d-lg-table-cell d-xl-table-cell text-center">
                                                    {T.t('r_profile_photo')}
                                                </th>
                                                <SortedColumn
                                                    datacell="firstName"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_firstname')}
                                                    sortkey="firstName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="lastName"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_lastname')}
                                                    sortkey="lastName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="userName"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_username')}
                                                    sortkey="userName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="lastLoginDate"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_last_login_date')}
                                                    sortkey="lastLoginDate"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="progress"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_progress')}
                                                    sortkey="progress"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                            </tr>
                                        </thead>
                                    </Table>
                                    <table style={{ textAlign: "center", width: "100%" }}>
                                        <a>{T.t('r_assignment_student_list_isEmpty_message')}</a></table></>
                            }
                            <div className="row-options justify-content-end">
                                <div
                                    className="page-sorting d-flex align-items-center justify-content-center"
                                    style={{ marginTop: '5px' }}
                                />
                                {this.props.studentList && this.props.studentList.length > 0 && (
                                    <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return Tablea;
    }
}

const mapStateToProps = (state: IAppState, ownProps: IStudentPageProps): IStudentPageProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IStudentPageProps = Object.assign({}, ownProps, {
        studentList: state.coursePage.courseStudentList ? state.coursePage.courseStudentList.results : [],
        filters: state.coursePage.courseStudentList ? state.coursePage.courseStudentList.filters : [],
        coursePageClassId: state.coursePage.coursePageClassId,
        userPreferences: state.profile.userPreferences.preferences,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        classes: state.coursePage.classes
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.courseStudentList === prev.coursePage.courseStudentList &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.classes === prev.coursePage.classes
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const container = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CourseStudentList);

export default container;
